import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
    mode: 'history',
    routes: [
        {
            path:'/',
            redirect:'/index'
        },
        {
            path:'/login',
            component(resolve)
            {
                require(['../pages/login/index'],resolve)
            }
        },
        {
            path:'/printagent',
            component(resolve)
            {
                require(['../pages/main/data/partworksign/printlist.vue'],resolve)
            }
        },
        {
            path:'/index',
            component(resolve)
            {
                require(['../pages/main/index'],resolve);
            },
            children:[
                {
                    path:'/main/system/menu',
                    component(resolve)
                    {
                        require(['../pages/main/system/menu/index'],resolve);
                    },
                },
                {
                    path:'/main/system/menu/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/system/menu/edit'],resolve);
                    }
                },
                {
                    path:'/main/system/user',
                    component(resolve)
                    {
                        require(['../pages/main/system/user/index'],resolve);
                    }
                },
                {
                    path:'/main/system/user/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/system/user/edit'],resolve);
                    }
                },
                {
                    path:'/main/system/role',
                    component(resolve)
                    {
                        require(['../pages/main/system/role/index'],resolve);
                    }
                },
                {
                    path:'/main/system/role/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/system/role/edit'],resolve);
                    }
                },
                {
                    path:'/main/system/huoma',
                    component(resolve)
                    {
                        require(['../pages/main/system/huoma/index'],resolve);
                    }
                },
                {
                    path:'/main/system/huoma/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/system/huoma/edit'],resolve);
                    }
                },
                {
                    path:'/main/system/huoma/list/:id',
                    component(resolve)
                    {
                        require(['../pages/main/system/huoma/list/index'],resolve);
                    }
                },
                {
                    path:'/main/system/huoma/list/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/system/huoma/list/edit'],resolve);
                    }
                },
                {
                    path:'/main/system/salesman',
                    component(resolve)
                    {
                        require(['../pages/main/system/salesman/index'],resolve);
                    }
                },
                {
                    path:'/main/system/salesman/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/system/salesman/edit'],resolve);
                    }
                },
                {
                    path:'/main/system/notice',
                    component(resolve)
                    {
                        require(['../pages/main/system/notice/index'],resolve);
                    }
                },
                {
                    path:'/main/system/notice/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/system/notice/edit'],resolve);
                    }
                },
                {
                    path:'/main/center/center',
                    component(resolve)
                    {
                        require(['../pages/main/center/center/index'],resolve);
                    }
                },
                {
                    path:'/main/center/user',
                    component(resolve)
                    {
                        require(['../pages/main/center/user/index'],resolve);
                    }
                },
                {
                    path:'/main/center/user/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/center/user/edit'],resolve);
                    }
                },
                {
                    path:'/main/center/merchant',
                    component(resolve)
                    {
                        require(['../pages/main/center/merchant/index'],resolve);
                    }
                },
                {
                    path:'/main/center/merchant/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/center/merchant/edit'],resolve);
                    }
                },
                {
                    path:'/main/center/setuser',
                    component(resolve)
                    {
                        require(['../pages/main/center/setuser/index'],resolve);
                    }
                },
                {
                    path:'/main/partwork/partwork',
                    component(resolve)
                    {
                        require(['../pages/main/partwork/partwork/index'],resolve);
                    }
                },
                {
                    path:'/main/partwork/partwork/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/partwork/partwork/edit'],resolve);
                    }
                },
                {
                    path:'/main/partwork/partworkclass',
                    component(resolve)
                    {
                        require(['../pages/main/partwork/partworkclass/index'],resolve);
                    }
                },
                {
                    path:'/main/partwork/partworkclass/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/partwork/partworkclass/edit'],resolve);
                    }
                },
                {
                    path:'/main/partwork/classcontent',
                    component(resolve)
                    {
                        require(['../pages/main/partwork/classcontent/index'],resolve);
                    }
                },
                {
                    path:'/main/partwork/classcontent/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/partwork/classcontent/edit'],resolve);
                    }
                },
                {
                    path:'/main/partwork/unsignfeedback',
                    component(resolve)
                    {
                        require(['../pages/main/partwork/unsignfeedback/index'],resolve);
                    }
                },
                {
                    path:'/main/finance/order',
                    component(resolve)
                    {
                        require(['../pages/main/finance/order/index'],resolve);
                    }
                },
                {
                    path:'/main/finance/orderdata',
                    component(resolve)
                    {
                        require(['../pages/main/finance/orderdata/index'],resolve);
                    }
                },
                {
                    path:'/main/finance/reimbursement',
                    component(resolve)
                    {
                        require(['../pages/main/finance/reimbursement/index'],resolve);
                    }
                },
                {
                    path:'/main/finance/reimbursement/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/finance/reimbursement/edit'],resolve);
                    }
                },
                {
                    path:'/main/product/vipcard',
                    component(resolve)
                    {
                        require(['../pages/main/product/vipcard/index'],resolve);
                    }
                },
                {
                    path:'/main/product/vipcard/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/product/vipcard/edit'],resolve);
                    }
                },
                {
                    path:'/main/product/workadded',
                    component(resolve)
                    {
                        require(['../pages/main/product/workadded/index'],resolve);
                    }
                },
                {
                    path:'/main/product/workadded/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/product/workadded/edit'],resolve);
                    }
                },
                {
                    path:'/main/data/partwork/pwdata',
                    component(resolve)
                    {
                        require(['../pages/main/data/partwork/pwdata'],resolve);
                    }
                },
                {
                    path:'/main/data/partworksign',
                    component(resolve)
                    {
                        require(['../pages/main/data/partworksign/index'],resolve);
                    }
                },
                {
                    path:'/main/constant/area',
                    component(resolve)
                    {
                        require(['../pages/main/constant/area/index'],resolve);
                    }
                },
                {
                    path:'/main/constant/area/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/constant/area/edit'],resolve);
                    }
                },
                {
                    path:'/main/constant/branch',
                    component(resolve)
                    {
                        require(['../pages/main/constant/branch/index'],resolve);
                    }
                },
                {
                    path:'/main/constant/branch/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/constant/branch/edit'],resolve);
                    }
                },
                {
                    path:'/main/constant/school',
                    component(resolve)
                    {
                        require(['../pages/main/constant/school/index'],resolve);
                    }
                },
                {
                    path:'/main/constant/school/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/constant/school/edit'],resolve);
                    }
                },
                {
                    path:'/main/constant/tags',
                    component(resolve)
                    {
                        require(['../pages/main/constant/tags/index'],resolve);
                    }
                },
                {
                    path:'/main/constant/tags/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/constant/tags/edit'],resolve);
                    }
                },
                {
                    path:'/main/constant/vipcode',
                    component(resolve)
                    {
                        require(['../pages/main/constant/vipcode/index'],resolve);
                    }
                },
                {
                    path:'/main/audit/partwork',
                    component(resolve)
                    {
                        require(['../pages/main/audit/partwork'],resolve);
                    }
                },
                {
                    path:'/main/audit/merchant',
                    component(resolve)
                    {
                        require(['../pages/main/audit/merchant'],resolve);
                    }
                },
                {
                    path:'/main/audit/unblocking',
                    component(resolve)
                    {
                        require(['../pages/main/audit/unblocking'],resolve);
                    }
                },
                {
                    path:'/main/audit/complaint',
                    component(resolve)
                    {
                        require(['../pages/main/audit/complaint'],resolve);
                    }
                },
                {
                    path:'/main/ad/ad',
                    component(resolve)
                    {
                        require(['../pages/main/ad/ad/index'],resolve);
                    }
                },
                {
                    path:'/main/ad/ad/edit/:id',
                    component(resolve)
                    {
                        require(['../pages/main/ad/ad/edit'],resolve);
                    }
                },
                {
                    path:'/main/promotion/partners',
                    component(resolve)
                    {
                        require(['../pages/main/promotion/partners/index'],resolve);
                    }
                },
                {
                    path:'/main/promotion/qrcode',
                    component(resolve)
                    {
                        require(['../pages/main/promotion/qrcode/index'],resolve);
                    }
                }
            ]
        }
    ]
})
